var map = {
	"./amossa-interior/content": 77850,
	"./anima-iris/content": 34527,
	"./annagram/content": 35892,
	"./appwrite/content": 46549,
	"./barbu/content": 17723,
	"./blender/content": 24499,
	"./casamancaise/content": 55266,
	"./desq/content": 25530,
	"./diambo/content": 67429,
	"./dina-groupe/content": 88398,
	"./finesse-fabrics/content": 30169,
	"./fold/content": 36758,
	"./guerlain/content": 33414,
	"./ingersoll/content": 95660,
	"./isif-dakar-business-school/content": 91304,
	"./jewoh/content": 42352,
	"./kaizen-business-support/content": 38110,
	"./kouna-bags/content": 28487,
	"./layepro-consulting/content": 99978,
	"./les-parfums-digor/content": 182,
	"./littlethingsdk/content": 11407,
	"./loolu-noonu/content": 52664,
	"./lucid/content": 29808,
	"./macaron-and-co/content": 27445,
	"./mela-label/content": 18405,
	"./menorah/content": 46127,
	"./milliardaire/content": 29360,
	"./montblanc/content": 45595,
	"./nakala/content": 36790,
	"./noema-venera/content": 17669,
	"./omana/content": 78609,
	"./oumou-group/content": 70260,
	"./portraitsofx/content": 34586,
	"./razer-blade/content": 48856,
	"./revolut/content": 60214,
	"./sanu/content": 32136,
	"./serene-senses/content": 87943,
	"./sisters-of-afrika/content": 28401,
	"./sobomb-dollz/content": 87405,
	"./sofatoo/content": 10062,
	"./sondelles/content": 89070,
	"./spacex/content": 77513,
	"./sycs/content": 52773,
	"./teewtickets/content": 67487,
	"./tennis/content": 61950,
	"./vessel/content": 88953,
	"./welly-food/content": 48361,
	"./xewlu/content": 20306,
	"./yafa-beauty/content": 52989,
	"./yellow/content": 6691,
	"./zara/content": 34343
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1881;
module.exports = webpackAsyncContext;